module.exports = __webpack_public_path__ + "media/managing_your_money/simple-c2f5b695.png";